import "./style.css";
import { Navbar } from "../../components/Navbar";
import SsoHandler from "../../utils/SSOhandler";
import { useEffect, useState } from "react";
import { useUserInfo } from "../../context/user";
import env from "../../config/env";

function ChatApp() {
  const [userActiveLocationWithUserId, setUserActiveLocationWithUserId] = useState({});
  const user = useUserInfo()[0];
  const userActiveLocation = useUserInfo()[4];
  const agencyData = useUserInfo()[11]
  const iframeUrl = env.Iframe_URL;
  const checkIfGhlUser = useUserInfo()[9];
  useEffect(() => {
    const updatedUserActiveLocation = { ...userActiveLocation, userId: user?._id, first_name: user?.userName };
    setUserActiveLocationWithUserId(updatedUserActiveLocation);
  }, []);

  return (
    <div className="m-auto position-relative" style={{ background: agencyData?.Customization?.body_bg ? agencyData?.Customization?.body_bg : '#fff' }}>
      <iframe src={`${iframeUrl}/?activepayload=${JSON.stringify({ ...userActiveLocation, checkIfGhlUser, userId: user?._id, first_name: user?.userName })}`} frameBorder="0" style={{ width: '100%', height: '100vh' }}></iframe>
    </div>
  );
}

export default ChatApp;
